import React, { useEffect, useState } from "react";
import Styles from "./Element.module.css";
import TextInput from "../../../../commons/Inputs/TextInput/TextInput";
import { useDispatch, useSelector } from "react-redux";
import SelectInput from "../../../../commons/Inputs/Select/SelectInput";
import { publicCityById } from "../../../../Redux/Slices/publicSlice";

const AddressSection = ({
  prefix,
  addressData,
  handleChange,
  errors,
  publicData,
}) => {
  const dispatch = useDispatch();

  const handleGetCity = (field, value) => {
    dispatch(publicCityById(value?.id));
    handleChange(field, value);
  };

  const renderTextInput = (
    field,
    heading,
    example,
    type = "text",
    readOnly = false
  ) => (
    <TextInput
      heading={`${heading} `}
      value={addressData[field]}
      onChange={(value) => handleChange(field, value)}
      example={example}
      type={type}
      height="45"
      error={errors[field]}
      readOnly={readOnly}
    />
  );

  const renderSelectInput = (field, heading, list, example) => (
    <SelectInput
      onChange={(value) =>
        heading === "State"
          ? handleGetCity(field, value)
          : handleChange(field, value)
      }
      list={list}
      value={addressData[field]}
      example={example}
      heading={`${heading} `}
      height="45px"
      error={errors[field]}
    />
  );

  return (
    <>
      <div className={Styles.layer1ElementsContainer}>
        {renderTextInput(`${prefix}_address`, "Full Address", `Enter Address`)}
      </div>
      <div className={Styles.layer3ElementsContainer}>
        {renderTextInput(`${prefix}_pincode`, "Pin Code", "Enter Pincode")}
        {renderSelectInput(
          `${prefix}_state`,
          "State",
          publicData?.stateUT,
          "Eg. Select State"
        )}
        {renderSelectInput(
          `${prefix}_city`,
          "City",
          publicData?.city,
          "Eg. Select City"
        )}
      </div>

      <div className={Styles.layer2ElementsContainer}>
        {renderTextInput(
          `${prefix}_contact`,
          "Name of the Contact Person",
          "Enter Contact Person Name"
        )}
        {renderTextInput(`${prefix}_email`, "Email", "Enter Email")}
      </div>
      <div className={Styles.layer2ElementsContainer}>
        {renderTextInput(`${prefix}_mobile`, "Mobile No.", "Enter Mobile No.")}
        {renderTextInput(
          `${prefix}_altMobile`,
          "Alternate Mobile No.",
          "Enter Alternate Mobile No."
        )}
      </div>
    </>
  );
};

const OfficeDetails = ({ userData, handleData, handleProceed }) => {
  const publicData = useSelector((state) => state?.publicSlice);

  const [addressData, setAddressData] = useState({
    registered_address: userData?.registered_address || "",
    registered_state: userData?.registered_state || {},
    registered_city: userData?.registered_city || {},
    registered_pincode: userData?.registered_pincode || "",
    registered_tel: userData?.registered_tel || "",
    registered_email: userData?.registered_email || "",
    registered_fax: userData?.registered_fax || "",
    registered_contact: userData?.registered_contact || "",
    registered_contactPhone: userData?.registered_contactPhone || "",
    registered_mobile: userData?.phone || userData?.userDetails?.phone || "",
    registered_altMobile: userData?.phone || userData?.userDetails?.phone || "",
    correspondence_address: userData?.correspondence_address || "",
    correspondence_state: userData?.correspondence_state || {},
    correspondence_city: userData?.correspondence_city || {},
    correspondence_pincode: userData?.correspondence_pincode || "",
    correspondence_tel: userData?.correspondence_tel || "",
    correspondence_email: userData?.correspondence_email || "",
    correspondence_fax: userData?.correspondence_fax || "",
    correspondence_contact: userData?.correspondence_contact || "",
    correspondence_contactPhone: userData?.correspondence_contactPhone || "",
    correspondence_mobile:
      userData?.phone || userData?.userDetails?.phone || "",
    correspondence_altMobile:
      userData?.phone || userData?.userDetails?.phone || "",
  });

  const [sameCheck, setSameCheck] = useState("same");
  const [errors, setErrors] = useState({});

  const handleChange = (field, value) => {
    setAddressData((prev) => {
      const updatedData = { ...prev, [field]: value };
      if (sameCheck === "same" && field.startsWith("registered_")) {
        const correspondenceField = field.replace(
          "registered_",
          "correspondence_"
        );
        updatedData[correspondenceField] = value;
      }
      return updatedData;
    });

    setErrors((prevErrors) => ({ ...prevErrors, [field]: "" }));
  };

  const validateFields = () => {
    const requiredFields = [
      `registered_address`,
      `registered_state`,
      `registered_city`,
      `registered_pincode`,
      `registered_tel`,
      `registered_email`,
      `registered_fax`,
      `registered_contact`,
      `registered_contactPhone`,
      `registered_mobile`,
      `registered_altMobile`,
      `correspondence_address`,
      `correspondence_state`,
      `correspondence_city`,
      `correspondence_pincode`,
      `correspondence_tel`,
      `correspondence_email`,
      `correspondence_fax`,
      `correspondence_contact`,
      `correspondence_contactPhone`,
      `correspondence_mobile`,
      `correspondence_altMobile`,
    ];

    const newErrors = {};
    requiredFields.forEach((field) => {
      if (
        !addressData[field] ||
        ((field.includes("_state") || field.includes("_city")) &&
          !addressData[field]?.id)
      ) {
        newErrors[field] = `${field
          .replace(/([A-Z])/g, " $1")
          .replace(/^./, (str) => str.toUpperCase())
          .replace(/_/g, " ")} is required`;
      }
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleContinue = (data) => {
    const newErrors = validateFields();
    setErrors(newErrors);
    if (Object.keys(newErrors).length !== 0) return;
    const address = [
      {
        type: "OFFICE",
        ...Object.fromEntries(
          Object.entries(addressData)
            .filter(([key]) => key.startsWith("registered_"))
            .map(([key, value]) => [key.replace("registered_", ""), value])
        ),
      },
      {
        type: "CORRESPONDENCE",
        ...Object.fromEntries(
          Object.entries(addressData)
            .filter(([key]) => key.startsWith("correspondence_"))
            .map(([key, value]) => [key.replace("correspondence_", ""), value])
        ),
      },
    ];

    handleData("address", address);
    handleProceed(data);
  };

  useEffect(() => {
    // If userData.address exists, update addressData from it
    if (Array.isArray(userData?.address) && userData.address.length > 0) {
      setAddressData((prev) => ({
        ...prev,
        // Registered (OFFICE)
        registered_address: userData.address[0]?.address || "",
        registered_state: userData.address[0]?.state || {},
        registered_city: userData.address[0]?.city || {},
        registered_pincode: userData.address[0]?.pincode || "",
        registered_tel: userData.address[0]?.tel || "",
        registered_email: userData.address[0]?.email || "",
        registered_fax: userData.address[0]?.fax || "",
        registered_contact: userData.address[0]?.contact || "",
        registered_contactPhone: userData.address[0]?.contactPhone || "",
        registered_mobile:
          userData.address[0]?.mobile || userData?.userDetails?.phone || "",
        registered_altMobile:
          userData.address[0]?.altMobile || userData?.userDetails?.phone || "",
        // Correspondence
        correspondence_address: userData.address[1]?.address || "",
        correspondence_state: userData.address[1]?.state || {},
        correspondence_city: userData.address[1]?.city || {},
        correspondence_pincode: userData.address[1]?.pincode || "",
        correspondence_tel: userData.address[1]?.tel || "",
        correspondence_email: userData.address[1]?.email || "",
        correspondence_fax: userData.address[1]?.fax || "",
        correspondence_contact: userData.address[1]?.contact || "",
        correspondence_contactPhone: userData.address[1]?.contactPhone || "",
        correspondence_mobile:
          userData.address[1]?.mobile || userData?.userDetails?.phone || "",
        correspondence_altMobile:
          userData.address[1]?.altMobile || userData?.userDetails?.phone || "",
      }));
    }
  }, [userData?.address, userData?.userDetails?.phone]);

  return (
    <div className={Styles.elementMain}>
      <div className={Styles.displayInputSection}>
        <div className={Styles.conterntHeader}>Company Address</div>
        <div className={Styles.detailsInpMainContainer}>
          <div
            className={`${Styles.subConterntHeader} ${Styles.corrOtherHeading}`}
          >
            Registered Address
          </div>
          <div className={Styles.divider}></div>
          <AddressSection
            prefix="registered"
            addressData={addressData}
            handleChange={handleChange}
            errors={errors}
            publicData={publicData}
          />

          <div className={Styles.corrAddressContainer}>
            <div
              className={`${Styles.subConterntHeader} ${Styles.corrOtherHeading}`}
            >
              Correspondence Address
            </div>
            <div className={Styles.corrAddSelection}>
              <div className={Styles.officeSelectionText}>
                <div className={Styles.sameCorrHeading}>
                  Same as that of Office Address
                </div>
                <div className={Styles.sel_button}>
                  <span
                    onClick={() => setSameCheck("same")}
                    className={
                      sameCheck === "same"
                        ? Styles.active_corr
                        : Styles.inAct_corr
                    }
                  >
                    Yes
                  </span>
                  <span
                    onClick={() => setSameCheck("different")}
                    className={
                      sameCheck === "different"
                        ? Styles.active_corr
                        : Styles.inAct_corr
                    }
                  >
                    No
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className={Styles.divider}></div>
          {sameCheck === "different" && (
            <AddressSection
              prefix="correspondence"
              addressData={addressData}
              handleChange={handleChange}
              errors={errors}
              publicData={publicData}
            />
          )}
        </div>
      </div>
      <div className={Styles.buttonSection}>
        <div className={Styles.prevBtn} onClick={() => handleProceed("prev")}>
          Back
        </div>
        <div className={Styles.nextBtn} onClick={() => handleContinue("next")}>
          Next
        </div>
      </div>
    </div>
  );
};

export default OfficeDetails;
